import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: {},
    error: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.GENERIC_DETAILS_REQUEST:
      return {
        ...state,
        data: {},
        isProgress: true,
      };
    case homeConstants.GENERIC_DETAILS_SUCCESS:
      return {
        data: action.response.data,
        isProgress: false,
      };
    case homeConstants.GENERIC_DETAILS_FAILURE:
      return {
        data: {},
        error: action.error,
        isProgress: false,
      };
    case homeConstants.RESET_GENERIC_DETAILS_DATA:
      return {
        data: {},
        isProgress: false,
      };
    case homeConstants.RESET_DATA:
      return {
        ...state,
        data: {},
      };
    default:
      return state;
  }
}
